import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { BoardListComponent } from './boardList/board.list.component';
import { BoardViewComponent } from './boardView/board.view.component';
import { ProjectHeaderComponent } from '../project/projectHeader/project.header.component';

import { BoardResolvesService } from './board-resolves.service';
import { BoardRest } from './board.rest';
import { TrackerQueryService } from '../../../plugins/tracker/services/tracker.query.service';

export const BOARD_STATES: any[] = [
    {
        name: 'home.project.summary.board',
        url: '/boards?page_num&page_size&sort_field&sort_dir&boardName&section&isShared',
        reloadOnSearch: false,
        params: {
            page_num: {
                value: 1,
                type: 'int',
                squash: true
            },
            page_size: {
                value: 20,
                type: 'int',
                squash: true
            },
            sort_field: {
                value: 'boardName',
                squash: true
            },
            sort_dir: {
                value: 'asc',
                squash: true
            },
            boardName: {
                value: '',
                squash: true
            },
            section: {
                value: '',
                squash: true
            },
            isShared: {
                value: '',
                squash: true
            }
        },
        resolve: [
            {
                token: 'queries',
                deps: ['$transition$', 'project', BoardResolvesService, TrackerQueryService],
                resolveFn: async (transition: any, project: any, boardResolvesService: BoardResolvesService, trackerQueryService: TrackerQueryService) => {
                    const params = transition.params();
                    return boardResolvesService.getProjectQueries(params, project, trackerQueryService);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: BoardListComponent
            }
        }
    },
    {
        name: 'home.project.summary.board.view',
        url: '/boards/:boardId/view?max_cards',
        reloadOnSearch: false,
        params: {
            max_cards: {
                value: 20,
                type: 'int',
                squash: true
            }
        },
        resolve: [
            {
                token: 'board',
                deps: ['$transition$', BoardResolvesService, BoardRest],
                resolveFn: async (transition: any, boardResolvesService: BoardResolvesService, boardRest: BoardRest) => {
                    const params = transition.params();
                    return boardResolvesService.getBoard(params, boardRest);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: BoardViewComponent
            }
        }
    }
];
